import type { NamespaceCatalog } from '@/i18n/ns';

const en = { resizePanel: 'Resize panel' };
export default {
  en,
  sv: { resizePanel: 'Ändra panelens storlek' },
  da: { resizePanel: 'Tilpas panelets størrelse' },
  fi: { resizePanel: 'Muuta paneelin kokoa' },
  de: { resizePanel: 'Panelgröße ändern' },
  fr: { resizePanel: 'Redimensionner le panneau' },
  es: { resizePanel: 'Cambiar el tamaño del panel' },
  it: { resizePanel: 'Ridimensiona il pannello' },
  nl: { resizePanel: 'Paneelgrootte aanpassen' },
  pt: { resizePanel: 'Redimensionar o painel' },
  pl: { resizePanel: 'Zmień rozmiar panelu' },
  cs: { resizePanel: 'Změnit velikost panelu' },
  sk: { resizePanel: 'Zmeniť veľkosť panela' },
  hu: { resizePanel: 'Panel átméretezése' },
  ro: { resizePanel: 'Redimensionează panoul' },
  bg: { resizePanel: 'Промяна на размера на панела' },
  el: { resizePanel: 'Αλλαγή μεγέθους πίνακα' },
  hr: { resizePanel: 'Promijeni veličinu ploče' },
  sl: { resizePanel: 'Spremeni velikost plošče' },
  et: { resizePanel: 'Muuda paneeli suurust' },
  lv: { resizePanel: 'Mainīt paneļa izmēru' },
  lt: { resizePanel: 'Keisti skydelio dydį' },
  ga: { resizePanel: 'Athraigh méid an phainéil' },
  mt: { resizePanel: 'Ibdel id-daqs tal-pannell' },
} satisfies NamespaceCatalog<keyof typeof en>;
